import "./departures.css";
import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import { useEffect, useState } from "react";
import {
  FaCircleCheck,
  FaCheck,
  FaRegCircleQuestion,
  FaAngleLeft,
  FaXmark,
  FaCircleExclamation,
} from "react-icons/fa6";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { GoXCircleFill, GoReply } from "react-icons/go";
import { BsClockFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

function Departures() {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [statusConfirmationModal, setStatusConfirmationModal] = useState({
    status: false,
    modal: "",
  });
  const [departures, setDepartures] = useState([]);
  const [currentDep, setCurrentDep] = useState({});
  const [messageAlert, setMessageAlert] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getDepartures();
  }, []);

  const getDepartures = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/departure`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      setDepartures(response.data.data.departures);
    } catch (error) {
      console.error("error", error);
    }
  };

  const confimTurnExit = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/departure/${currentDep.collection_id}`;
      const body = {
        user_id: localStorage.getItem("collection-email"),
        status: 1,
      };

      await axios.put(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });
      setStatusConfirmationModal({ status: false, modal: "" });
      setCurrentDep({});
      await getDepartures();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Ocurrio un error al confirmar la salida.",
        icon: "error",
      });
      setStatusConfirmationModal({ status: false, modal: "" });
    }
  };

  const confimTurnExitStore = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/departure/${currentDep.collection_id}`;
      const body = {
        user_id: localStorage.getItem("collection-email"),
        status: 2,
      };

      await axios.put(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });
      setStatusConfirmationModal({ status: false, modal: "" });
      setCurrentDep({});
      await getDepartures();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Ocurrio un error al confirmar el regreso al almacen.",
        icon: "error",
      });
      setStatusConfirmationModal({ status: false, modal: "" });
    }
  };

  const confirmPendingTurn = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/departure/${currentDep.collection_id}`;
      const body = {
        user_id: localStorage.getItem("collection-email"),
        status: 3,
      };

      await axios.put(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });
      setStatusConfirmationModal({ status: false, modal: "" });
      setCurrentDep({});
      await getDepartures();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Ocurrio un error al confirmar el regreso al almacen.",
        icon: "error",
      });
      setStatusConfirmationModal({ status: false, modal: "" });
    }
  };

  const getErrorMessage = async (departure) => {
    try {
      setStatusConfirmationModal({ status: true, modal: "question" });
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/departure/${departure.collection_id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });
      setMessageAlert(response.data.data.description);
    } catch (error) {
      console.error(error);
      setMessageAlert(
        "Error, por favor contacta a uno de nuestros colaboradores."
      );
    }
  };

  const getInformation = async (departure) => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/departure/find/${departure.turn_employee_id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });
      setCurrentDep(response.data.data.turn);
    } catch (error) {
      console.error(error);
      setMessageAlert(
        "Error, por favor contacta a uno de nuestros colaboradores."
      );
    }
  };

  const setStatus = (number) => {
    switch (number) {
      case "1":
        return { text: "Buscando", color: "dep-bg-blue" };
      case "2":
        return { text: "Encontrado", color: "bg-green" };
      case "3":
        return { text: "Encontrado parcial", color: "bg-orange" };
      case "4":
        return { text: "No encontrado", color: "seek-bg-red" };
      default:
        break;
    }
  };

  const renderConfirmationModal = () => {
    return (
      <Modal
        show={
          statusConfirmationModal.status &&
          statusConfirmationModal.modal === "confirmation"
        }
        onHide={() => setStatusConfirmationModal({ status: false, modal: "" })}
        className="modal-container"
      >
        <Modal.Body>
          <div className="modal-icon">
            <svg
              width="139"
              height="129"
              viewBox="0 0 139 129"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.5429 24.3527C67.9325 28.8887 73.3255 35.7744 75.7294 43.7421C78.1333 51.7098 77.3863 60.2234 73.6257 67.7157C80.3401 72.5623 88.5134 75.3015 96.9837 75.544C105.454 75.7864 113.79 73.5197 120.808 69.0662C127.825 64.6126 133.166 58.1988 136.072 50.7364C138.978 43.2741 139.301 35.1429 136.995 27.4986C134.688 19.8544 129.87 13.0862 123.225 8.15608C116.581 3.22593 108.447 0.384739 99.981 0.0363606C91.5149 -0.312018 83.1471 1.85015 76.067 6.21552C68.9869 10.5809 63.5548 16.9273 60.5429 24.3527ZM98.2305 34.2871C101.66 34.2871 104.444 36.8966 104.444 40.1117V56.8307C104.444 58.3755 103.789 59.857 102.624 60.9493C101.459 62.0417 99.8784 62.6553 98.2305 62.6553C96.5826 62.6553 95.0023 62.0417 93.837 60.9493C92.6718 59.857 92.0172 58.3755 92.0172 56.8307V40.1117C92.0172 36.8966 94.8008 34.2871 98.2305 34.2871ZM90.9435 19.5625C90.9435 23.9519 94.8206 25.881 97.5545 26.1606L98.2504 26.1979C100.964 26.1979 105.547 24.334 105.547 19.5625C105.547 15.1638 101.67 13.2346 98.9364 12.9551L98.2405 12.9178C95.5265 12.9178 90.9435 14.7817 90.9435 19.5625ZM40.4116 75.8329C43.6378 75.8942 46.8445 75.3514 49.8441 74.2364C52.8436 73.1213 55.5757 71.4565 57.8804 69.3393C60.1851 67.2222 62.0159 64.6952 63.2659 61.9065C64.5158 59.1177 65.1596 56.1232 65.1596 53.0983C65.1596 50.0734 64.5158 47.0789 63.2659 44.2901C62.0159 41.5014 60.1851 38.9744 57.8804 36.8573C55.5757 34.7401 52.8436 33.0753 49.8441 31.9602C46.8445 30.8452 43.6378 30.3024 40.4116 30.3637C34.0647 30.4841 28.021 32.9323 23.5777 37.1828C19.1345 41.4332 16.6458 47.1472 16.6458 53.0983C16.6458 59.0494 19.1345 64.7634 23.5777 69.0138C28.021 73.2643 34.0647 75.7125 40.4116 75.8329ZM5.34118e-05 121.293C-0.0164364 111.78 3.78577 102.609 10.6511 95.603C17.5163 88.5971 26.9421 84.2691 37.0552 83.4789C47.1682 82.6888 57.2282 85.4944 65.2359 91.3383C73.2436 97.1822 78.6128 105.636 80.2765 115.021H131.544C133.521 115.021 135.418 115.757 136.816 117.068C138.214 118.379 139 120.157 139 122.01C139 123.864 138.214 125.642 136.816 126.953C135.418 128.264 133.521 129 131.544 129H7.65489C5.76726 129 3.95007 128.328 2.56998 127.121C1.18989 125.913 0.349639 124.26 0.218763 122.495C0.0793337 122.108 0.00880301 121.702 0.00999476 121.293H5.34118e-05Z"
                fill="#020C41"
              />
            </svg>
          </div>
          <h3 className="modal-text">
            ¿Desea confirmar la salida de este turno?
          </h3>
          <div className="modal-buttons">
            <Button
              className="confirm-button"
              onClick={() => {
                confimTurnExit();
              }}
            >
              Sí
            </Button>
            <Button
              onClick={() => {
                setStatusConfirmationModal({ status: false, modal: "" });
              }}
              className="cancel-button"
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const renderConfirmationRedModal = () => {
    return (
      <Modal
        show={
          statusConfirmationModal.status &&
          statusConfirmationModal.modal === "confirmationRed"
        }
        onHide={() => setStatusConfirmationModal({ status: false, modal: "" })}
        className="modal-container"
      >
        <Modal.Body>
          <div className="modal-icon">
            <svg
              width="139"
              height="129"
              viewBox="0 0 139 129"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.5429 24.3527C67.9325 28.8887 73.3255 35.7744 75.7294 43.7421C78.1333 51.7098 77.3863 60.2234 73.6257 67.7157C80.3401 72.5623 88.5134 75.3015 96.9837 75.544C105.454 75.7864 113.79 73.5197 120.808 69.0662C127.825 64.6126 133.166 58.1988 136.072 50.7364C138.978 43.2741 139.301 35.1429 136.995 27.4986C134.688 19.8544 129.87 13.0862 123.225 8.15608C116.581 3.22593 108.447 0.384739 99.981 0.0363606C91.5149 -0.312018 83.1471 1.85015 76.067 6.21552C68.9869 10.5809 63.5548 16.9273 60.5429 24.3527ZM98.2305 34.2871C101.66 34.2871 104.444 36.8966 104.444 40.1117V56.8307C104.444 58.3755 103.789 59.857 102.624 60.9493C101.459 62.0417 99.8784 62.6553 98.2305 62.6553C96.5826 62.6553 95.0023 62.0417 93.837 60.9493C92.6718 59.857 92.0172 58.3755 92.0172 56.8307V40.1117C92.0172 36.8966 94.8008 34.2871 98.2305 34.2871ZM90.9435 19.5625C90.9435 23.9519 94.8206 25.881 97.5545 26.1606L98.2504 26.1979C100.964 26.1979 105.547 24.334 105.547 19.5625C105.547 15.1638 101.67 13.2346 98.9364 12.9551L98.2405 12.9178C95.5265 12.9178 90.9435 14.7817 90.9435 19.5625ZM40.4116 75.8329C43.6378 75.8942 46.8445 75.3514 49.8441 74.2364C52.8436 73.1213 55.5757 71.4565 57.8804 69.3393C60.1851 67.2222 62.0159 64.6952 63.2659 61.9065C64.5158 59.1177 65.1596 56.1232 65.1596 53.0983C65.1596 50.0734 64.5158 47.0789 63.2659 44.2901C62.0159 41.5014 60.1851 38.9744 57.8804 36.8573C55.5757 34.7401 52.8436 33.0753 49.8441 31.9602C46.8445 30.8452 43.6378 30.3024 40.4116 30.3637C34.0647 30.4841 28.021 32.9323 23.5777 37.1828C19.1345 41.4332 16.6458 47.1472 16.6458 53.0983C16.6458 59.0494 19.1345 64.7634 23.5777 69.0138C28.021 73.2643 34.0647 75.7125 40.4116 75.8329ZM5.34118e-05 121.293C-0.0164364 111.78 3.78577 102.609 10.6511 95.603C17.5163 88.5971 26.9421 84.2691 37.0552 83.4789C47.1682 82.6888 57.2282 85.4944 65.2359 91.3383C73.2436 97.1822 78.6128 105.636 80.2765 115.021H131.544C133.521 115.021 135.418 115.757 136.816 117.068C138.214 118.379 139 120.157 139 122.01C139 123.864 138.214 125.642 136.816 126.953C135.418 128.264 133.521 129 131.544 129H7.65489C5.76726 129 3.95007 128.328 2.56998 127.121C1.18989 125.913 0.349639 124.26 0.218763 122.495C0.0793337 122.108 0.00880301 121.702 0.00999476 121.293H5.34118e-05Z"
                fill="#020C41"
              />
            </svg>
          </div>
          <h3 className="modal-text">
            ¿Deseas confirmar el regreso al almacen de este turno?
          </h3>
          <div className="modal-buttons">
            <Button
              className="confirm-button"
              onClick={() => {
                confimTurnExitStore();
              }}
            >
              Sí
            </Button>
            <Button
              onClick={() => {
                setStatusConfirmationModal({ status: false, modal: "" });
              }}
              className="cancel-button"
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const renderPendingModal = () => {
    return (
      <Modal
        show={
          statusConfirmationModal.status &&
          statusConfirmationModal.modal === "pending"
        }
        onHide={() => setStatusConfirmationModal({ status: false, modal: "" })}
        className="modal-container"
      >
        <Modal.Body>
          <div className="modal-icon">
            <svg
              width="139"
              height="129"
              viewBox="0 0 139 129"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.5429 24.3527C67.9325 28.8887 73.3255 35.7744 75.7294 43.7421C78.1333 51.7098 77.3863 60.2234 73.6257 67.7157C80.3401 72.5623 88.5134 75.3015 96.9837 75.544C105.454 75.7864 113.79 73.5197 120.808 69.0662C127.825 64.6126 133.166 58.1988 136.072 50.7364C138.978 43.2741 139.301 35.1429 136.995 27.4986C134.688 19.8544 129.87 13.0862 123.225 8.15608C116.581 3.22593 108.447 0.384739 99.981 0.0363606C91.5149 -0.312018 83.1471 1.85015 76.067 6.21552C68.9869 10.5809 63.5548 16.9273 60.5429 24.3527ZM98.2305 34.2871C101.66 34.2871 104.444 36.8966 104.444 40.1117V56.8307C104.444 58.3755 103.789 59.857 102.624 60.9493C101.459 62.0417 99.8784 62.6553 98.2305 62.6553C96.5826 62.6553 95.0023 62.0417 93.837 60.9493C92.6718 59.857 92.0172 58.3755 92.0172 56.8307V40.1117C92.0172 36.8966 94.8008 34.2871 98.2305 34.2871ZM90.9435 19.5625C90.9435 23.9519 94.8206 25.881 97.5545 26.1606L98.2504 26.1979C100.964 26.1979 105.547 24.334 105.547 19.5625C105.547 15.1638 101.67 13.2346 98.9364 12.9551L98.2405 12.9178C95.5265 12.9178 90.9435 14.7817 90.9435 19.5625ZM40.4116 75.8329C43.6378 75.8942 46.8445 75.3514 49.8441 74.2364C52.8436 73.1213 55.5757 71.4565 57.8804 69.3393C60.1851 67.2222 62.0159 64.6952 63.2659 61.9065C64.5158 59.1177 65.1596 56.1232 65.1596 53.0983C65.1596 50.0734 64.5158 47.0789 63.2659 44.2901C62.0159 41.5014 60.1851 38.9744 57.8804 36.8573C55.5757 34.7401 52.8436 33.0753 49.8441 31.9602C46.8445 30.8452 43.6378 30.3024 40.4116 30.3637C34.0647 30.4841 28.021 32.9323 23.5777 37.1828C19.1345 41.4332 16.6458 47.1472 16.6458 53.0983C16.6458 59.0494 19.1345 64.7634 23.5777 69.0138C28.021 73.2643 34.0647 75.7125 40.4116 75.8329ZM5.34118e-05 121.293C-0.0164364 111.78 3.78577 102.609 10.6511 95.603C17.5163 88.5971 26.9421 84.2691 37.0552 83.4789C47.1682 82.6888 57.2282 85.4944 65.2359 91.3383C73.2436 97.1822 78.6128 105.636 80.2765 115.021H131.544C133.521 115.021 135.418 115.757 136.816 117.068C138.214 118.379 139 120.157 139 122.01C139 123.864 138.214 125.642 136.816 126.953C135.418 128.264 133.521 129 131.544 129H7.65489C5.76726 129 3.95007 128.328 2.56998 127.121C1.18989 125.913 0.349639 124.26 0.218763 122.495C0.0793337 122.108 0.00880301 121.702 0.00999476 121.293H5.34118e-05Z"
                fill="#020C41"
              />
            </svg>
          </div>
          <h3 className="modal-text">
            ¿Deseas asignar como pendiente este turno?
          </h3>
          <div className="modal-buttons">
            <Button
              className="confirm-button"
              onClick={() => {
                confirmPendingTurn();
              }}
            >
              Sí
            </Button>
            <Button
              onClick={() => {
                setStatusConfirmationModal({ status: false, modal: "" });
                setCurrentDep({});
              }}
              className="cancel-button"
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const renderQuestionModal = () => {
    return (
      <Modal
        show={
          statusConfirmationModal.status &&
          statusConfirmationModal.modal === "question"
        }
        onHide={() => {
          setStatusConfirmationModal({ status: false, modal: "" });
          setMessageAlert("");
        }}
        className="modal-container"
      >
        <Modal.Body>
          <div className="close-modal-btn">
            <span
              onClick={() => {
                setStatusConfirmationModal({ status: false, modal: "" });
                setMessageAlert("");
              }}
            >
              <FaXmark />
            </span>
          </div>

          <div className="modal-icon">
            <svg
              width="100"
              height="100"
              viewBox="0 0 150 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M75 0C116.423 0 150 33.5775 150 75C150 116.423 116.423 150 75 150C33.5775 150 0 116.423 0 75C0 33.5775 33.5775 0 75 0ZM75 105C73.0109 105 71.1032 105.79 69.6967 107.197C68.2902 108.603 67.5 110.511 67.5 112.5C67.5 114.489 68.2902 116.397 69.6967 117.803C71.1032 119.21 73.0109 120 75 120C76.9891 120 78.8968 119.21 80.3033 117.803C81.7098 116.397 82.5 114.489 82.5 112.5C82.5 110.511 81.7098 108.603 80.3033 107.197C78.8968 105.79 76.9891 105 75 105ZM75 33.75C67.7894 33.75 60.8742 36.6144 55.7755 41.713C50.6769 46.8117 47.8125 53.7269 47.8125 60.9375C47.8125 62.9266 48.6027 64.8343 50.0092 66.2408C51.4157 67.6473 53.3234 68.4375 55.3125 68.4375C57.3016 68.4375 59.2093 67.6473 60.6158 66.2408C62.0223 64.8343 62.8125 62.9266 62.8125 60.9375C62.815 58.7253 63.4195 56.5554 64.5614 54.6607C65.7032 52.7659 67.3392 51.2176 69.294 50.1819C71.2488 49.1462 73.4487 48.662 75.6577 48.7814C77.8667 48.9008 80.0015 49.6192 81.8333 50.8596C83.6651 52.0999 85.1248 53.8155 86.0557 55.8223C86.9867 57.8291 87.3539 60.0514 87.118 62.251C86.882 64.4506 86.0518 66.5445 84.7164 68.3082C83.381 70.0719 81.5907 71.4389 79.5375 72.2625C74.4675 74.2875 67.5 79.4775 67.5 88.125V90C67.5 91.9891 68.2902 93.8968 69.6967 95.3033C71.1032 96.7098 73.0109 97.5 75 97.5C76.9891 97.5 78.8968 96.7098 80.3033 95.3033C81.7098 93.8968 82.5 91.9891 82.5 90C82.5 88.17 82.875 87.255 84.4575 86.475L85.11 86.175C90.9661 83.8192 95.8203 79.4996 98.8405 73.9569C101.861 68.4141 102.859 61.9934 101.663 55.7954C100.468 49.5974 97.1541 44.0082 92.2893 39.986C87.4246 35.9638 81.3122 33.7592 75 33.75Z"
                fill="#035CF7"
              />
            </svg>
          </div>

          <h3 className="modal-text" style={{ color: "#001f5b" }}>
            ¿Por qué no se ha encontrado/se ha encontrado parcialmente el turno?
          </h3>

          <p className="custom-message">{messageAlert}</p>

          <Button
            className="btn-close-dep"
            onClick={() => {
              setStatusConfirmationModal({ status: false, modal: "" });
              setMessageAlert("");
            }}
          >
            Cerrar
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  const renderInformationModal = () => {
    return (
      <Modal
        show={
          statusConfirmationModal.status &&
          statusConfirmationModal.modal === "information"
        }
        onHide={() => {
          setStatusConfirmationModal({ status: false, modal: "" });
          setCurrentDep({});
        }}
        className="modal-container"
      >
        <Modal.Body>
          <div className="modal-icon">
            <svg
              width="150"
              height="150"
              viewBox="0 0 150 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M75 150C84.8491 150 94.6018 148.06 103.701 144.291C112.801 140.522 121.069 134.997 128.033 128.033C134.997 121.069 140.522 112.801 144.291 103.701C148.06 94.6018 150 84.8491 150 75C150 65.1509 148.06 55.3982 144.291 46.2987C140.522 37.1993 134.997 28.9314 128.033 21.967C121.069 15.0026 112.801 9.47814 103.701 5.70903C94.6018 1.93993 84.8491 -1.46764e-07 75 0C55.1088 2.96403e-07 36.0322 7.90176 21.967 21.967C7.90176 36.0322 0 55.1088 0 75C0 94.8912 7.90176 113.968 21.967 128.033C36.0322 142.098 55.1088 150 75 150ZM73.0667 105.333L114.733 55.3333L101.933 44.6667L66.1 87.6583L47.5583 69.1083L35.775 80.8917L60.775 105.892L67.225 112.342L73.0667 105.333Z"
                fill="#66C87B"
              />
            </svg>
          </div>
          <div className="guide-container">
            <h3 className="seek-color-blue-bold">{currentDep.customer_name}</h3>
            {currentDep.awb &&
              currentDep.awb.map((guide, index) => (
                <p className="guide-number" key={index}>
                  {guide}
                </p>
              ))}
            <Button
              className="btn-confirm-seek"
              onClick={() => {
                setStatusConfirmationModal({ status: false, modal: "" });
                setCurrentDep({});
              }}
            >
              Continuar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const renderBtnsAction = (departure) => (
    <>
      {departure.search_status === "2" && departure.checkout_status === "1" && (
        <>
          <div
            className="box-container dep-bg-blue"
            onClick={() => {
              setStatusConfirmationModal({
                status: true,
                modal: "confirmation",
              });
              setCurrentDep(departure);
            }}
          >
            <div className="dep-tooltip">Confirmar</div>
            <FaCheck />
          </div>
          <div className="box-container-none seek-bg-white"></div>
          <div className="box-container-none seek-bg-white"></div>
        </>
      )}
      {departure.search_status === "2" && departure.checkout_status === "0" && (
        <>
          <div
            className="box-container dep-bg-red"
            onClick={() => {
              setStatusConfirmationModal({
                status: true,
                modal: "confirmationRed",
              });
              setCurrentDep(departure);
            }}
          >
            <div className="dep-tooltip">Regresar</div>
            <GoReply />
          </div>
          <div className="box-container-none seek-bg-white"></div>
          <div className="box-container-none seek-bg-white"></div>
        </>
      )}
      {departure.search_status === "3" && departure.checkout_status === "1" && (
        <>
          <div
            className="box-container dep-bg-green"
            onClick={() => {
              setStatusConfirmationModal({ status: true, modal: "question" });
              getErrorMessage(departure);
            }}
          >
            <div className="dep-tooltip">Ver justificación</div>
            <FaRegCircleQuestion />
          </div>
          <div
            className="box-container dep-bg-blue"
            onClick={() => {
              setStatusConfirmationModal({
                status: true,
                modal: "confirmation",
              });
              setCurrentDep(departure);
            }}
          >
            <div className="dep-tooltip">Confirmar</div>
            <FaCheck />
          </div>
          <div
            className="box-container dep-bg-red"
            onClick={() => {
              setStatusConfirmationModal({
                status: true,
                modal: "confirmationRed",
              });
              setCurrentDep(departure);
            }}
          >
            <div className="dep-tooltip">Regresar</div>
            <GoReply />
          </div>
        </>
      )}
      {departure.search_status === "3" && departure.checkout_status === "0" && (
        <>
          <div
            className="box-container dep-bg-red"
            onClick={() => {
              setStatusConfirmationModal({
                status: true,
                modal: "confirmationRed",
              });
              setCurrentDep(departure);
            }}
          >
            <div className="dep-tooltip">Regresar</div>
            <GoReply />
          </div>
          <div className="box-container-none seek-bg-white"></div>
          <div className="box-container-none seek-bg-white"></div>
        </>
      )}
      {departure.search_status === "4" && (
        <>
          <div
            className="box-container dep-bg-green"
            onClick={() => {
              setStatusConfirmationModal({ status: true, modal: "question" });
              getErrorMessage(departure);
            }}
          >
            <div className="dep-tooltip">Ver justificación</div>
            <FaRegCircleQuestion />
          </div>
          <div
            className="box-container dep-bg-orange"
            onClick={() => {
              setStatusConfirmationModal({ status: true, modal: "pending" });
              setCurrentDep(departure);
            }}
          >
            <div className="dep-tooltip">Pendiente</div>
            <BsClockFill />
          </div>
          <div className="box-container-none seek-bg-white"></div>
        </>
      )}
    </>
  );

  const logOut = () => {
    localStorage.clear();
    navigate("/amc-domestico/collection/");
  };

  return (
    <>
      <div className="departures-container">
        <div className="departures-header">
          <img src={amc_logo} alt="Aeromexico" />
        </div>
        <div className="info-content">
          <p>{currentDate}</p>
          <p>{currentTime}</p>
          <div className="return-content">
            <FaAngleLeft onClick={logOut} />
          </div>
        </div>

        <div className="departures-body">
          <h3>Salidas</h3>

          <table className="table-format">
            <thead>
              <tr>
                <th>Turno</th>
                <th>Nombre de empleado/# de empleado</th>
                <th className="text-center">
                  Estatus <br /> Buscador
                </th>
                <th className="text-center">
                  Estatus <br /> Mostrador
                </th>
                <th className="text-center">Acciones</th>
              </tr>
            </thead>

            <tbody>
              {departures.map((departure, index) => (
                <tr key={index}>
                  <td className="borderStyle">{departure.turn_number}</td>
                  <td className="borderStyle">
                    {departure.employe_name} ({departure.employe_number})
                  </td>
                  <td className="borderStyle text-center">
                    <p
                      className={`search-text ${
                        setStatus(departure.search_status).color
                      }`}
                    >
                      {setStatus(departure.search_status).text}
                    </p>
                  </td>
                  <td className="borderStyle text-center" style={{borderRight: '1px solid #000'}}>
                    {departure.checkout_status === "1" && (
                      <p className="search-text bg-green">
                        Aceptado <FaCircleCheck />{" "}
                      </p>
                    )}
                    {departure.checkout_status === "0" && (
                      <p className="search-text seek-bg-red">
                        No Aceptado <GoXCircleFill />{" "}
                      </p>
                    )}
                  </td>

                  <td className="text-center actionTdSeek">
                    <div
                      className="box-container dep-bg-gray"
                      onClick={() => {
                        setStatusConfirmationModal({
                          status: true,
                          modal: "information",
                        });
                        getInformation(departure);
                      }}
                    >
                      <div className="dep-tooltip">Ver detalle</div>
                      <FaCircleExclamation />
                    </div>
                    {renderBtnsAction(departure)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Confirmation Modal */}
      {renderConfirmationModal()}

      {/* Confirmation Red Modal */}
      {renderConfirmationRedModal()}

      {/* Pending Modal */}
      {renderPendingModal()}

      {/* Question Modal */}
      {renderQuestionModal()}

      {/* Information Modal */}
      {renderInformationModal()}
    </>
  );
}

export default Departures;
